import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  addLink(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.containerTarget.insertAdjacentHTML('beforeend', content);
  }

  removeLink(event) {
    event.preventDefault();
    const wrapper = event.target.closest('.nested-form-link');
    if (wrapper) wrapper.remove();
  }

  updateFavicon(event) {
    const url = event.target.value;
    const faviconContainer = event.target.closest('.nested-form-link').querySelector('.favicon-img');
    if (url) {
      try {
        const faviconUrl = `https://www.google.com/s2/favicons?domain=${new URL(url).hostname}&sz=32`;
        faviconContainer.src = faviconUrl;
        faviconContainer.classList.remove('hidden');
      } catch (e) {
        faviconContainer.classList.add('hidden');
      }
    } else {
      faviconContainer.classList.add('hidden');
    }
  }

  ensureProtocol(event) {
    let value = event.target.value.trim();
    if (value && !/^https?:\/\//i.test(value)) {
      value = 'https://' + value;
      event.target.value = value;
      this.updateFavicon(event);
    }
  }
} 